$(document).ready(function(){
  function refreshCart(cart) {
    console.log("cart refreshed");
    if(typeof window.BOLD !== 'undefined'
    && typeof window.BOLD.common !== 'undefined'
    && typeof window.BOLD.common.cartDoctor !== 'undefined') {
      cart = window.BOLD.common.cartDoctor.fix(cart);
    }

    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;

    $cartForm.data('total-discount', cart.total_discount);

  /*  $.each(cart.items , function(index , item){
        if(item.id === 47928933482804){
           cart.item_count = (cart.item_count - item.quantity) + 1;
        }
    });*/
    
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));

    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');

      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;

      $.each(cart.items, (index, item) => {
        //console.log(item.presentment_price);
        const itemDiscounts = item.discounts;
        let discountMessage = '';

        for (let i = 0; i < itemDiscounts.length; i++) {
          const { title } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;

        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}" data-key="${item.key}" data-base-price="${item.presentment_price}">`
          + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">'
              + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />`
            + '</div></a>';
        }

        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;

        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }

        if (item.properties) {
          $.each(item.properties, (title, value) => {
            if (value) {
              if(title !== '_Timestamp'){
               cartItemsHTML += `<div class="line-item">${title}: ${value} </div>`;
              }
            }
          });
        }

        cartItemsHTML += '</div>'
        if(item.handle !== 'shield-new'){
        cartItemsHTML += '<div class="mini-cart__item-price">';

        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `/products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              productFinalPrice = productData.price;
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          },
        });

        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="${item.key}" style="display:none !important;"></span><span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="${item.key}" style="display:none !important;"></span><span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(item.price, $('body').data('money-format'));
          if (item.price > 0) {
            cartItemsHTML += `<span class="Bold-theme-hook-DO-NOT-DELETE bold_cart_item_price" data-item-key="${item.key}" style="display:none !important;"></span><span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }

        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';

          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }

          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }

        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }

        
          
        if(item.properties['_Timestamp'] === ''){
          cartItemsHTML += '<div class="product-quantity-box">';
        }else{
          cartItemsHTML += `<div class="product-quantity-box" data-line-stamp="${item.properties['_Timestamp']}">`;
        }
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div>';
        }
        cartItemsHTML += '</div></div>';
        if(item.properties['_Timestamp'] === ''){
         cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
        }else{
          cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart" data-line-stamp="${item.properties['_Timestamp']}"><span class="remove-icon"></span></a>`;
        }
      });

      const cartDiscounts = cart.cart_level_discount_applications;

      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const { title } = cartDiscounts[i];

        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }

      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>`
            + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }

    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }

    if(typeof BOLD === 'object' && BOLD.common && BOLD.common.eventEmitter && typeof BOLD.common.eventEmitter.emit === 'function') {
      BOLD.common.eventEmitter.emit("BOLD_COMMON_cart_loaded");
    }
  }

  
  $(document).on("click",".add-to-cart--ajax",function(){
     const btn = $(this);
     const variantId = $(this).attr("data-variant-id");
     const checkMark = '<svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="checkmark checkmark-active"> <path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>'
     $.ajax({
       type:"POST",
       url:"/cart/add.js",
       dataType:"json",
       data:{'items':[{'id': variantId,'quantity': 1}]},
       success:function(data){
         console.log("success");
         btn.addClass("force_bg_change").html(checkMark);
         setTimeout(() => {
           btn.removeClass("force_bg_change").html("Add to cart");
         },2000);
         $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                   $('.logo-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }
                }
                // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
                  }
              }, 500);
            },
          });         
       },
       error:function(err){
         console.log(err);
       }
     })
  })

  $(document).on("click",".swatch-element",function(){
     $(this).siblings().removeClass("selected__swatch");
     $(this).addClass("selected__swatch");
  });

  const swatchContainer = $(".swatch_options");

  if (swatchContainer.length) {
    const swatches = swatchContainer.find(".swatch-element");
    swatches.each(function () {
      const radioInput = $(this).prev("input[type=radio]");
      if (radioInput.is(":checked")) {
        $(this).addClass("selected__swatch");
      } else {
        $(this).removeClass("selected__swatch");
      }
    });
  }

  $(document).on("click",".option-info-icon",function(){
     const content = $(this).attr('data-content');
     const options ={
       baseClass: "option-info-popup"
     };
     $.fancybox.open(content , options);    
  })

  /* Hide mini-cart for mobile when Selleasy popup appears */

    const screenWidth = $(window).width();
    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (screenWidth <= 480) {
                    if (mutation.target.className.includes('lb-upsell-prevent-scroll')) {
                        if (mutation.target.className.includes('blocked-scroll')) {
                            $('.cart-container').removeClass('active_link');
                            $('body').removeClass('blocked-scroll');
                        }
                    }
                }
            }
        });
    });

    const config = {
        attributes: true,
        attributeFilter: ['class'],
    };

    observer.observe(document.body, config);  

  //========================= Quick add to cart popup on PDP ==============================
   
  // Quantity increase
  $(document).on("click", ".quick-q-plus", function () {
    const input = $(this).closest(".quick-quantity-wrapper").find("input");
    let value = parseInt(input.val()) || 1;
    input.val(value + 1);
  });

  // Quantity decrease
  $(document).on("click", ".quick-q-minus", function () {
    const input = $(this).closest(".quick-quantity-wrapper").find("input");
    let value = parseInt(input.val()) || 1;
    if (value > 1) {
      input.val(value - 1);
    }
  });

  // Allow only numbers in input
  $(document).on("input", "#quick-input-quantity", function () {
    let value = $(this).val();
    value = value.replace(/[^0-9]/g, ""); // remove non-numbers

    if (value === "" || parseInt(value) < 1) {
      value = 1;
    }

    $(this).val(value);
  });

  // Add to Cart
  $(document).on("click", ".quick-btn-atc", function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    const btn = $(this);
    const variantId = btn.attr("data-variant-id");
    const qtyInput = btn.closest(".quick-atc-actions").find("#quick-input-quantity");
    const quantity = parseInt(qtyInput.val()) || 1;

    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      dataType: "json",
      data: {
        items: [{
          id: variantId,
          quantity: quantity
        }]
      },
      success: function (data) {
        // Refresh cart (same as your reference)
        $.ajax({
          url: "/cart.js",
          dataType: "json",
          cache: false,
          success(cart) {
            setTimeout(function () {
              if (typeof refreshCart === "function") {
                refreshCart(cart);
                openMiniCart();
              }
            }, 300);
          }
        });
      },
      error: function (err) {
        console.error(err);
      }
    });
  });  

// Target elements
const targetSection = document.querySelector(".product-main"); // section to observe
const quickAtc = document.querySelector(".quick-atc-section");

// Create observer
const observer_popup = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // Section is visible → HIDE quick ATC
      quickAtc.style.display = "none";
    } else {
      // Section is NOT visible → SHOW quick ATC
      quickAtc.style.display = "block";
    }
  });
}, {
  threshold: 0.2 // adjust (0 = trigger early, 1 = fully visible)
});

// Start observing
observer_popup.observe(targetSection);  

});